import React, { useEffect } from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { ForYouIfSection } from '../components/ForYouIfSection';
import { ProblemSolutionSection } from '../components/ProblemSolutionSection';
import { WhatsIncludedSection } from '../components/WhatsIncludedSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ExpertEndorsement } from '../components/ExpertEndorsement';
import { PurchaseSection } from '../components/PurchaseSection';
import { BonusSection } from '../components/BonusSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen font-sans text-[#5C4033] bg-[#FFF8F0] selection:bg-[#D4A5A5] selection:text-white" data-id="element-203">
      <style data-id="element-204">{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400;1,600&family=Crimson+Text:ital,wght@0,400;0,600;1,400&display=swap');
        
        .font-serif {
          font-family: 'Playfair Display', serif;
        }
        
        body {
          font-family: 'Crimson Text', serif;
        }
      `}</style>

      <AnnouncementBar data-id="element-205" />

      <main data-id="element-206">
        <HeroSection onCtaClick={scrollToPurchase} data-id="element-207" />
        <ForYouIfSection data-id="element-208" />
        <ProblemSolutionSection data-id="element-209" />
        <WhatsIncludedSection data-id="element-210" />
        <TestimonialsSection data-id="element-211" />
        <ExpertEndorsement data-id="element-212" />
        <PurchaseSection data-id="element-213" />
        <BonusSection data-id="element-214" />
        <FAQSection data-id="element-215" />
        <FinalCTA onCtaClick={scrollToPurchase} data-id="element-216" />
      </main>

      <Footer data-id="element-217" />
    </div>;
}